/*
  L'Etabli - chargement progressif des collections.

  Pourquoi pas du defilement infini pur : on n'atteindrait plus jamais le bas
  de page, donc plus de mentions legales, plus de CGV, plus de contact - et le
  bouton "retour" du navigateur ramenerait en haut d'une liste de 200 produits.

  Compromis retenu : les deux premieres pages arrivent toutes seules quand le
  client approche du bas, puis un bouton "Charger plus" prend le relais. Le
  pied de page redevient atteignable, et si le JavaScript echoue la pagination
  numerotee d'origine reste en place.
*/
(function () {
  'use strict';

  var CHARGEMENTS_AUTO = 2; // au-dela, c'est le client qui decide

  function Progressif(conteneur) {
    this.conteneur = conteneur;
    this.grille = conteneur.querySelector('#product-grid');
    this.pagination = conteneur.querySelector('.pagination-wrapper');
    this.auto = 0;
    this.enCours = false;
    if (!this.grille || this.grille.tagName !== 'UL') return;
    if (!this.pagination) return;
    this.suivante = this.pagination.getAttribute('data-next-url') || '';
    if (!this.suivante) return;
    this.installer();
  }

  Progressif.prototype.installer = function () {
    var self = this;

    // la pagination numerotee reste dans le document (referencement, et repli
    // si le script casse) mais on la masque puisqu'on prend le relais
    this.pagination.hidden = true;

    var zone = document.createElement('div');
    zone.className = 'letabli-charger';
    zone.innerHTML =
      '<button type="button" class="button button--secondary letabli-charger__bouton">Charger plus de produits</button>' +
      '<p class="letabli-charger__compte" aria-live="polite"></p>';
    this.pagination.parentNode.insertBefore(zone, this.pagination);
    this.zone = zone;
    this.bouton = zone.querySelector('.letabli-charger__bouton');
    this.compte = zone.querySelector('.letabli-charger__compte');

    this.bouton.addEventListener('click', function () {
      self.auto = CHARGEMENTS_AUTO; // un clic manuel coupe l'automatique
      self.charger();
    });

    // declenchement automatique quand la zone approche de l'ecran
    if ('IntersectionObserver' in window) {
      this.guetteur = new IntersectionObserver(
        function (entrees) {
          if (!entrees[0].isIntersecting) return;
          if (self.auto >= CHARGEMENTS_AUTO) return;
          self.auto++;
          self.charger();
        },
        { rootMargin: '400px 0px' }
      );
      this.guetteur.observe(zone);
    }
  };

  Progressif.prototype.charger = function () {
    var self = this;
    if (this.enCours || !this.suivante) return;
    this.enCours = true;
    this.bouton.classList.add('letabli-charger--occupe');
    this.bouton.setAttribute('aria-busy', 'true');
    var texteInitial = this.bouton.textContent;
    this.bouton.textContent = 'Chargement…';

    fetch(this.suivante, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('reponse ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nouvelleGrille = doc.querySelector('#product-grid');
        if (!nouvelleGrille) throw new Error('grille introuvable');

        var articles = nouvelleGrille.querySelectorAll(':scope > li');
        var ajoutes = 0;
        for (var i = 0; i < articles.length; i++) {
          var li = articles[i];
          // l'animation d'apparition au defilement se declenche a l'entree
          // dans l'ecran ; sur un element injecte elle laisse la carte
          // invisible. On la neutralise.
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          li.removeAttribute('data-cascade');
          li.removeAttribute('style');
          self.grille.appendChild(document.importNode(li, true));
          ajoutes++;
        }

        var paginationSuivante = doc.querySelector('.pagination-wrapper');
        self.suivante = paginationSuivante
          ? paginationSuivante.getAttribute('data-next-url') || ''
          : '';

        // l'adresse suit le defilement : un rafraichissement ne renvoie pas
        // le client au tout debut de la liste
        try {
          var lue = paginationSuivante && paginationSuivante.getAttribute('data-page-url');
          if (lue) window.history.replaceState({}, '', lue);
        } catch (e) {
          /* certains navigateurs refusent, sans consequence */
        }

        var total = self.grille.querySelectorAll(':scope > li').length;
        self.compte.textContent = ajoutes + ' produits de plus — ' + total + ' affichés';

        if (!self.suivante) {
          self.bouton.remove();
          self.compte.textContent = 'Vous avez vu les ' + total + ' produits de cette sélection.';
          if (self.guetteur) self.guetteur.disconnect();
        }
      })
      .catch(function () {
        // en cas d'echec, on rend la main a la pagination d'origine plutot
        // que de laisser le client bloque
        self.zone.remove();
        self.pagination.hidden = false;
        if (self.guetteur) self.guetteur.disconnect();
      })
      .then(function () {
        self.enCours = false;
        if (self.bouton && self.bouton.isConnected) {
          self.bouton.classList.remove('letabli-charger--occupe');
          self.bouton.removeAttribute('aria-busy');
          self.bouton.textContent = texteInitial;
        }
      });
  };

  // Filtres et tri : Dawn remplace le CONTENU de #ProductGridContainer mais
  // garde l'element lui-meme. Un marqueur pose sur le conteneur survivrait
  // donc au remplacement et empecherait toute reinstallation - c'est ce qui
  // faisait disparaitre le bouton des qu'on cochait un filtre.
  // On se fie donc a la presence reelle du bouton dans le document.
  function demarrer() {
    var conteneur = document.getElementById('ProductGridContainer');
    if (!conteneur) return;
    if (conteneur.querySelector('.letabli-charger')) return; // deja en place
    var pagination = conteneur.querySelector('.pagination-wrapper');
    if (!pagination || pagination.hidden) return;
    new Progressif(conteneur);
  }

  document.addEventListener('DOMContentLoaded', demarrer);
  if (document.readyState !== 'loading') demarrer();

  var racine = document.getElementById('ProductGridContainer');
  if (racine && 'MutationObserver' in window) {
    var minuteur = null;
    new MutationObserver(function () {
      // on laisse le remplacement se terminer avant de se reinstaller
      clearTimeout(minuteur);
      minuteur = setTimeout(demarrer, 60);
    }).observe(racine, { childList: true, subtree: true });
  }
})();
